import React, { useState } from "react";
import Radio from "@material-ui/core/Radio";
import { useTranslation } from "react-i18next";
import { commentTypes } from "../../firebase/comments";
import { makeStyles } from "@material-ui/core/styles";
import { colors } from "../../theme";

interface Props {
  onChange: (type: string) => void;
}

const useStyles = makeStyles((theme) => ({
  commentType: {
    padding: "3px",
    "&$checked": {
      color: colors.CHECKBOX,
    },
    transform: "scale(0.75)",
    msTransform: "scale(0.75)",
    WebkitTransform: "scale(0.75)"
  },
  checked: {},
  options: {
    width: "100%",
    color: "#ababab"
  },
  span: {
    marginLeft: "-3px"
  }
}));

export default function CommentTypePicker({ onChange }: Props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const [commentType, setCommentType] = useState<string>(commentTypes.COMMENT);

  const handleCommentType = (event: any) => {
    setCommentType(event.target.value);
    onChange(event.target.value);
  };

  return (
    <>
      {t("commentform.choosecommenttype")}{" "}
      <div className={classes.options}>
        <Radio
          checked={commentType === commentTypes.COMMENT}
          onChange={handleCommentType}
          value={commentTypes.COMMENT}
          name="commentType"
          color="default"
          classes={{ root: classes.commentType, checked: classes.checked }}
        />
        <span className={classes.span}>{t("commentform.commenttype")}</span>
        <Radio
          checked={commentType === commentTypes.ACTION}
          onChange={handleCommentType}
          value={commentTypes.ACTION}
          name="commentType"
          color="default"
          classes={{ root: classes.commentType, checked: classes.checked }}
        />
        <span className={classes.span}>{t("commentform.actiontype")}</span>
        <Radio
          checked={commentType === commentTypes.PROPOSAL}
          onChange={handleCommentType}
          value={commentTypes.PROPOSAL}
          name="commentType"
          color="default"
          classes={{ root: classes.commentType, checked: classes.checked }}
        />
        <span className={classes.span}>{t("commentform.proposaltype")}</span>
      </div>
    </>
  );
}
